<template>
  <div class="log">
    <v-btn
      small
      @click="getList()"
      v-if="section === 'ReadyToPay' && isVisible !== 0"
      class="payy-ass-btn green-button"
    >
      Adv. Ready To Pay</v-btn
    >

    <v-btn
      style="width: 30px; height: 30px; cursor: pointer"
      outline
      small
      fab
      v-if="this.$route.name == 'Accounts' && !section"
      @click="getList()"
      color="orange"
    >
      <v-icon>edit</v-icon>
    </v-btn>

    <button
      v-if="this.$route.name != 'Accounts' && !section"
      color="orange"
      outline
      class="pay-ass-btn padding_all assignment-details-action-btn"
      type="button"
      @click.stop="dialog = false"
      @click="getList()"
    >
      <v-icon small color="white">visibility</v-icon>
      Details
    </button>
    <v-dialog
      v-model="dialog"
      class="advance-details-dialog"
      content-class="oms-financial-details-dialog oms-financial-details-dialog--advance"
      max-width="94rem"
      persistent
    >
      <v-form ref="form" onsubmit="return false;" class="layout__list">
        <v-card class="advance-details-card">
          <header class="advance-details-header">
            <div class="advance-details-header__brand">
              <div class="advance-details-header__badge" aria-hidden="true">
                <v-icon>account_balance_wallet</v-icon>
              </div>
              <div class="advance-details-header__copy">
                <h2 class="advance-details-title">Request Advance Details</h2>
              </div>
            </div>
            <v-btn
              class="advance-details-close"
              icon
              aria-label="Close request advance details"
              title="Close"
              @click="dialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </header>
          <v-progress-linear
            indeterminate
            color="trukkin-theme darken-2"
            v-show="processing"
          ></v-progress-linear>
          <v-spacer class="advance-details-dialog-body">
            <v-card-text class="nospace">
              <v-card-text class="nospace">
                <loading :active.sync="loading" />

                <v-layout class="advance-details-summary">
                  <v-flex xs7 pt-2 pl-1 v-if="advanceAmount"
                    ><span class="dashboard-style"
                      >Total Advance Requested:
                    </span>
                    {{ advanceAmount }} {{ currency }}</v-flex
                  >
                  <v-flex xs6 pt-2 pl-2 v-if="totaladvancePaid"
                    ><span class="dashboard-style">Total Advance Paid: </span>
                    {{ totaladvancePaid }} {{ currency }}</v-flex
                  >
                  <v-flex xs6 pt-2 pl-2 v-if="totaldata"
                    ><span class="dashboard-style"><v-icon small>{{ modeIcon }}</v-icon>
                      {{ operatorRoleLabel }} Price: </span
                    >{{ paymentAmount }} {{ currency }}</v-flex
                  >

                  <v-flex
                    xs12
                    class="button__align"
                    pl-4
                    v-if="!purchaseInvoiceGenerated"
                  >
                    <ReadyToPayPopup
                      v-if="$props.section !== 'Accounts' && isMarkedAllRead"
                      :confirmationTitle="'Comments'"
                      :cancelBtn="'Cancel'"
                      :confirmBtn="'Add Comment'"
                      :driverCreditDuration="
                        assignDetails.driverData
                          ? assignDetails.driverData.driverPaymentDuration
                          : null
                      "
                      :assignId="assignId"
                      :assignStatus="status"
                      @refresh-list="refreshList()"
                      :type="'all'"
                    />

                    <GenerateAdvance
                      :assId="assignID"
                      :jobType="jobType"
                      v-if="
                        this.$route.name != 'Accounts' &&
                        $props.section !== 'Accounts'
                      "
                      v-permissions="'generate-advance-jobs'"
                      :status="status"
                      :viewOnly="viewOnly"
                      :assignedToTransporter="assignedToTransporter"
                      :driverCreditDuration="
                        assignDetails.driverData
                          ? assignDetails.driverData.driverPaymentDuration
                          : null
                      "
                      :ownerType="ownerType"
                      :currency="currency"
                      :invoiceCity="invoiceCity"
                      :invoiceCompany="invoiceCompany"
                      :maximumAdvanceLeftAmount="maximumAdvanceLeftAmount"
                      :additionalCharges="$props.additionalCharges"
                      @generateAdvance="closeMessage()"
                      :totalAmount="this.paymentAmount"
                      :totalAdvanceAmount="advanceAmount"
                      :totaladvancePaid="totaladvancePaid"
                    />

                    <GenerateAdvance
                      :assId="assignID"
                      :jobType="jobType"
                      v-if="
                        this.$route.name == 'Accounts' &&
                        $props.section !== 'Accounts'
                      "
                      v-permissions="'add-advance-for-accounts'"
                      :assignedToTransporter="assignedToTransporter"
                      :ownerType="ownerType"
                      :status="status"
                      :viewOnly="viewOnly"
                      :currency="currency"
                      :invoiceCity="invoiceCity"
                      :invoiceCompany="invoiceCompany"
                      :maximumAdvanceLeftAmount="maximumAdvanceLeftAmount"
                      @generateAdvance="closeMessage()"
                      :driverCreditDuration="
                        assignDetails.driverData
                          ? assignDetails.driverData.driverPaymentDuration
                          : null
                      "
                      :totalAmount="this.paymentAmount"
                      :additionalCharges="$props.additionalCharges"
                      :totalAdvanceAmount="this.advanceAmount"
                      :totaladvancePaid="totaladvancePaid"
                    />

                    <v-btn
                      class="ma-2"
                      v-if="
                        this.$route.name != 'Accounts' &&
                        $props.section !== 'Accounts' &&
                        advanceStatus
                      "
                      outline
                      v-permissions="'cancel-advance'"
                      color="red"
                      @click="check('all')"
                      :disabled="
                        status <= 1 ||
                        status === 4 ||
                        customerStatus == 'view' ||
                        purchaseInvoiceGenerated
                      "
                    >
                      Cancel All Advance
                    </v-btn>
                    <v-btn
                      class="ma-2"
                      v-if="
                        this.$route.name == 'Accounts' &&
                        advanceStatus &&
                        $props.section !== 'Accounts'
                      "
                      outline
                      v-permissions="'add-advance-for-accounts'"
                      color="red"
                      @click="check()"
                      :disabled="
                        status <= 1 ||
                        (status === 4 && customerStatus == 'view') ||
                        !purchaseInvoiceGenerated
                      "
                    >
                      Cancel All Advance
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-data-table
                id="TransporterListTable"
                class="advance-details-table popup-data-table"
                hide-actions
                :headers="headers"
                :items="items"
                style="word-break: break-word"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    <v-layout row justify-center>
                      <activityLogs
                        :subType="17"
                        :id="props.item._id"
                        :type="'advance'"
                      />
                      <span class="pl-1 pt-1">
                        {{ props.item.advanceAmount }} {{ currency }}</span
                      >
                    </v-layout>
                  </td>
                  <td v-if="props.item.actualAmountPaid">
                    {{ props.item.actualAmountPaid }} {{ currency }}
                  </td>
                  <td v-else>N.A</td>
                  <td v-if="props.item.updatedAt">
                    {{ props.item.employeeName }}({{
                      props.item.employeeId
                    }})<br />
                    {{ getTime3(props.item.updatedAt) }}
                  </td>
                  <td v-else>
                    {{ props.item.employeeName }}({{ props.item.employeeId }})
                  </td>
                  <td v-if="props.item.creditorModeOfPayment == 'Cash'">
                    {{ props.item.creditorModeOfPayment }}
                  </td>
                  <td
                    v-else-if="
                      props.item.creditorModeOfPayment == 'Bank Transfer'
                    "
                  >
                    {{ props.item.creditorModeOfPayment }}<br />
                    Swift No. -
                    {{ props.item.swiftNumber || "N.A" }} <br />
                    IBAN No. -
                    {{ props.item.IBANNumber || "N.A" }}<br />
                    Account No. -
                    {{ props.item.accountNumber || "N.A" }} <br />Account Holder
                    Name-
                    {{ props.item.accountHolderName || "N.A" }}
                  </td>
                  <td v-else>-</td>
                  <td>
                    {{ props.item.modeOfPayment || "N.A" }}<br />
                    {{ props.item.bankName }}
                  </td>
                  <td>
                    {{
                      props.item.actualPaidDate && props.item.actualPaidTime
                        ? getTime4(props.item.actualPaidDate) +
                          " " +
                          props.item.actualPaidTime
                        : "-"
                    }}
                  </td>
                  <td>
                    <v-icon small>{{ modeIcon }}</v-icon>
                    {{
                      assignmentDetails.driverFirstName
                        ? assignmentDetails.driverFirstName +
                          " " +
                          assignmentDetails.driverLastName
                        : ""
                    }}<br />(via {{ ownerType }})
                    <br />
                    {{ assignDetails.driverData ? assignDetails.driverId : ""
                    }}<br />
                    <span v-if="assignDetails.driverData">
                      <template v-if="assignDetails.truckNumber">
                        {{ assignDetails.truckPrefix }}-{{
                          assignDetails.truckNumber
                        }}</template
                      >
                      <template v-else>
                        {{ assignDetails.driverData.truckPrefix }}-{{
                          assignDetails.driverData.truckNumber
                        }}</template
                      >
                    </span>
                  </td>
                  <td>{{ getStatus(props.item.advanceStatus) }}</td>
                  <td>
                    <span v-if="props.item.adjustedAmount">
                      {{ props.item.adjustedAmount }} {{ currency }} <br />{{
                        props.item.remarksForAdjustment
                          ? "(" + props.item.remarksForAdjustment + ")"
                          : ""
                      }}</span
                    >
                    <span v-else>N.A</span>
                  </td>

                  <td style="word-break: break-word">
                    {{
                      props.item.cancelAdvanceReason ||
                      props.item.rejectionReason ||
                      "-"
                    }}
                  </td>
                  <td v-if="!purchaseInvoiceGenerated">
                    <ReadyToPayPopup
                      v-if="
                        $props.section !== 'Accounts' &&
                        props.item.advanceStatus === 'Issued'
                      "
                      :confirmationTitle="'Comments'"
                      :driverCreditDuration="
                        assignDetails.driverData
                          ? assignDetails.driverData.driverPaymentDuration
                          : null
                      "
                      :details="props.item"
                      :assignStatus="assignDetails.assignmentStatus"
                      :cancelBtn="'Cancel'"
                      :assignId="assignId"
                      :confirmBtn="'Add Comment'"
                      @refresh-list="refreshList()"
                      :type="'single'"
                    />
                    <v-btn
                      v-if="
                        $props.section !== 'Accounts' &&
                        status != 4 &&
                        !purchaseInvoiceGenerated &&
                        (props.item.advanceStatus === 'Ready' ||
                          props.item.advanceStatus === 'Issued' ||
                          props.item.advanceStatus === 'Rejected')
                      "
                      class="cancel-ass-btn"
                      small
                      outline
                      v-permissions="'cancel-advance'"
                      color="red"
                      @click="check('single', props.item._id)"
                      :disabled="status <= 1 || customerStatus == 'view'"
                    >
                      Cancel
                    </v-btn>
                    <editAdvance
                      :jobType="jobType"
                      v-if="
                        props.item.advanceStatus === 'Issued' ||
                        props.item.advanceStatus === 'Ready' ||
                        props.item.advanceStatus === 'Rejected'
                      "
                      :assId="assignID"
                      v-permissions="'add-advance-for-accounts'"
                      :isCancel="props.item.isCancel"
                      :driverCreditDuration="
                        assignDetails.driverData
                          ? assignDetails.driverData.driverPaymentDuration
                          : null
                      "
                      :purchaseInvoiceGenerated="purchaseInvoiceGenerated"
                      :ownerType="ownerType"
                      :serialId="props.item._id"
                      :status="assignDetails.assignmentStatus"
                      :assignedToTransporter="assignedToTransporter"
                      :viewOnly="viewOnly"
                      :currency="currency"
                      :details="props.item"
                      :modeOfPayment="props.item.modeOfPayment"
                      :totaladvancePaid="totaladvancePaid"
                      :additionalCharges="additionalCharges"
                      :invoiceCity="invoiceCity"
                      :invoiceCompany="invoiceCompany"
                      :bankNames="props.item.bankName"
                      :totalAdvanceRequestedArray="totalAdvanceRequested"
                      :maximumAdvanceLeftAmount="maximumAdvanceLeftAmount"
                      @editAdvance="closeMessage()"
                      :advance="props.item.advanceAmount.toString()"
                      :totalAmount="paymentAmount"
                      :totalAdvanceAmount="advanceAmount"
                    />
                    <proof-of-delivery
                      v-if="
                        props.item.advanceStatus == 'Paid' &&
                        props.item.document &&
                        props.item.document.length
                      "
                      :deliveryProof="props.item.document"
                    />
                  </td>
                  <td v-else></td>
                </template>
              </v-data-table>

              <span class="page-count-span totalpages"
                >Total Pages - {{ totalPages }}</span
              >

              <PaginationButtons
                v-if="dialog"
                :url="`/dmsAdmin/getAdvanceList`"
                :payload="payload"
                :callback="callback"
                :componentKey="componentKey"
                v-on:pagination-payload="paginationPayload"
              />
              <success-dialog
                :content="x.message"
                :show="x.success"
                :onclose="closeMessage"
              />
              <v-dialog
                v-model="cancelDialog"
                persistent
                max-width="28rem"
                content-class="advance-cancel-dialog"
              >
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-card class="advance-cancel-card">
                    <header class="advance-cancel-header">
                      <div class="advance-cancel-header__brand">
                        <div class="advance-cancel-header__badge" aria-hidden="true">
                          <v-icon>block</v-icon>
                        </div>
                        <h2 class="advance-cancel-title-text">Cancel Advance</h2>
                      </div>
                      <v-btn
                        icon
                        class="advance-cancel-close"
                        @click.prevent="closeAdvance()"
                        title="Close"
                      >
                        <v-icon>close</v-icon>
                      </v-btn>
                    </header>

                    <div class="advance-cancel-body">
                      <div class="advance-cancel-field">
                        <label class="advance-cancel-label"
                          >Reason for cancelling Advance*</label
                        >
                        <v-select
                          class="pt-0 currencyTitle advance-cancel-input"
                          v-model="cancelType"
                          :items="cancellationType"
                          label="Select your option"
                          persistent-hint
                          :menu-props="{ offsetY: true }"
                          return-object
                          single-line
                          box
                        ></v-select>
                        <v-text-field
                          class="pt-0 currencyTitle advance-cancel-input"
                          v-if="cancelType.value == 'Other’s'"
                          type="text"
                          single-line
                          box
                          label="Enter your reason"
                          required
                          v-model="cancellationReason"
                          :value="cancellationReason"
                        />
                      </div>
                    </div>

                    <v-card-actions class="advance-cancel-actions">
                      <v-spacer></v-spacer>
                      <v-btn
                        class="advance-cancel-secondary-btn"
                        flat
                        @click="closeAdvance()"
                        >Cancel</v-btn
                      >
                      <v-btn
                        class="advance-cancel-primary-btn"
                        color="orange darken-1"
                        dark
                        :disabled="loading"
                        @click="cancelAdvance()"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-form>
                <v-snackbar
                  :timeout="3000"
                  bottom
                  color="red darken-2"
                  v-model="x.error"
                  class="white--text"
                  v-if="x.error"
                  >{{ x.error }}</v-snackbar
                >
              </v-dialog>

              <v-snackbar
                :timeout="3000"
                color="red darken-2"
                v-model="error"
                class="white--text"
                v-if="error"
                >{{ error }}</v-snackbar
              >
            </v-card-text>
          </v-spacer>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import _ from "lodash";
import { EventBus } from "../../event-bus.js";
import "moment/locale/es"; // without this line it didn't work
moment.locale("en-in");
import Loading from "vue-loading-overlay";
import { generateAdvanceList } from "@/constants/datatable-headers.js";
import SuccessDialog from "@/components/Common/SuccessDialog";
import activityLogs from "../Common/activityLogs.vue";
import AdvancePaid from "@/components/Accounts/Popups/AdvancePaid";
import GenerateAdvance from "@/components/Pop-ups/GenerateAdvance";
import ProofOfDelivery from "@/components/Pop-ups/ProofOfDelivery";
import ReadyToPayPopup from "@/components/Pop-ups/ReadyToPayPopup.vue";
import editAdvance from "@/components/Pop-ups/editAdvance";
import ErrorBox from "@/components/Common/ErrorBox";
import moment from "moment";
import {
  StorageKeys,
  JobTypes,
  JobListTypes,
  CancellationType,
} from "../../constants/constants";
import { async } from "q";
import PaginationButtons from "@/components/Pagination/Pagination-New";
import {
  getModeIcon,
  getOperatorRoleLabel,
  getUnitNoLabel,
} from "@/utils/shipmentLabels";
export default {
  created() {
    this.customerStatus = this.$props.viewOnly;
    this.cancellationType = CancellationType;
    if (localStorage.getItem("workingCountries")) {
      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      this.workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          this.workingCountry = key.value;
        }
      });
    }

    EventBus.$on("countryChanged", (val) => {
      if (this.$route.name == "documents") {
        this.$router.push(`/jobs`);
      }
      this.workingCountry = val.value;
      this.loading = true;
    });
    this.payload = {
      skip: "0",
      limit: "15",
      assignmentId: this.$props.assignId,
      workingCountry: this.workingCountry,
    };
    this.JobTypes = JobTypes;
    if (!navigator.onLine) {
      this.loading = false;
      this.x.error = "Please check your internet connection";
      setTimeout(() => {
        this.x.error = "";
      }, 3000);
      return;
    }
  },
  components: {
    PaginationButtons,
    SuccessDialog,
    ErrorBox,
    Loading,
    activityLogs,
    editAdvance,
    GenerateAdvance,
    ReadyToPayPopup,
    ProofOfDelivery,
    AdvancePaid,
  },
  props: {
    loadingstop: Function,
    loader: Boolean,
    assignId: String,
    advancePaid: Number,
    additionalCharges: Number,
    viewOnly: Boolean,
    section: String,
    isVisible: Number,
  },

  data() {
    return {
      opeartionName: "",
      workingCountry: null,
      count: 0,
      rejectDialog: false,
      rejectReason: null,
      assignedToTransporter: "",
      assignDetails: {},
      customerStatus: "",
      bankName: "",
      ownerType: "",
      purchaseInvoiceGenerated: false,
      advanceId: null,
      JobTypes: [],
      invoiceCompany: "",
      invoiceCity: "",
      totaldata: "",
      advanceAmount: null,
      totaladvancePaid: null,
      advanceStatus: "",
      currency: "",
      cancellationType: [],
      cancellationReason: "",
      cancelType: "",
      status: null,
      jobType: "",
      jobId: "",
      assignID: null,
      isRejectTrue: false,
      paymentAmount: null,
      assignmentDetails: {},
      isMarkedAllRead: false,
      maximumAdvanceLeftAmount: 0,
      totalAdvanceRequested: [],
      error: "",
      valid: true,
      lazy: false,
      cancelDialog: false,
      isCancelAll: null,
      cancelreason: "",
      loading: false,
      dialog: false,
      dialog2: false,
      processing: false,
      x: {
        message: "The advance has been successfully cancelled",
        loading: true,
        success: false,
        menu: false,

        error: null,
        missingField: null,
      },
      search: "",
      componentKey: 0,

      totalPages: "",

      payload: {},

      headers: generateAdvanceList,
      items: [],
    };
  },
  computed: {
    operatorRoleLabel() {
      return getOperatorRoleLabel(this.jobType);
    },
    modeIcon() {
      return getModeIcon(this.jobType);
    },
  },
  watch: {},
  methods: {
    getStatus(status) {
      switch (status) {
        case "Paid":
          return "Paid";
        case "Issued":
          return "Requested";
        case "Rejected":
          return "Rejected";
        case "Cancel":
          return "Cancelled";
        case "Ready":
          return "Ready To Pay";
        case "PartiallyPaid":
          return "Partial Paid";

        default:
          return "Unknown";
      }
    },
    refreshList() {
      this.$emit("assignment-list-refresh");
      this.componentKey++;
    },
    getBankName() {
      if (this.invoiceCity == "1" && this.invoiceCompany == "1") {
        this.bankName = "Alinma Bank - Dammam";
      } else if (this.invoiceCity == "2" && this.invoiceCompany == "1") {
        this.bankName = "Alinma Bank - Jeddah";
      } else if (this.invoiceCity == "3" && this.invoiceCompany == "1") {
        this.bankName = "Alinma Bank - Riyadh";
      } else if (this.invoiceCity == "1" && this.invoiceCompany == "2") {
        this.bankName = "Mashreq Bank PSJC";
      } else if (this.invoiceCity == "2" && this.invoiceCompany == "2") {
        this.bankName = "EMIRATES NBD Bank";
      }
      return this.bankName;
    },
    getList() {
      if (localStorage.getItem("workingCountries")) {
        this.workingCountries = JSON.parse(
          localStorage.getItem("workingCountries")
        );
        this.workingCountries.forEach((key, index) => {
          if (key.isSelected) {
            this.workingCountry = key.value;
          }
        });
      }

      this.dialog = true;
      this.payload = {
        skip: "0",
        limit: "15",
        assignmentId: this.$props.assignId,
        workingCountry: this.workingCountry,
      };
    },
    openReject(type) {
      this.rejectDialog = true;
    },
    async check(type, id) {
      if (this.$route.name == "Accounts")
        this.operationName = "add-advance-for-accounts";
      if (this.$route.name != "Accounts") this.operationName = "cancel-advance";

      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.cancelDialog = true;
        this.isCancelAll = type;
        this.advanceId = id;
      } else {
        return;
      }
    },
    closeAdvance() {
      this.cancelDialog = false;
      this.cancelType = "";
      this.cancellationReason = "";
    },
    closeReject() {
      this.rejectDialog = false;

      this.rejectReason = "";
    },
    async cancelAdvance() {
      this.loading = true;
      this.operationName = "cancel-advance";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        if (!this.cancelType) {
          this.error = "Please select cancellation reason before moving ahead";
          setTimeout(() => {
            this.x.error = "";
          }, 3000);
          this.loading = false;
          return false;
        }
        if (this.cancelType.value == "Other’s") {
          if (!this.cancellationReason.trim()) {
            this.error = "Please enter cancellation reason before moving ahead";
            setTimeout(() => {
              this.x.error = "";
            }, 3000);
            this.loading = false;
            return false;
          }
        }
        const data = {
          assignmentId: this.$props.assignId,
        };
        if (this.isCancelAll == "single") {
          data.advanceId = this.advanceId;
          data.isCancelAll = false;
        }
        if (this.isCancelAll == "all") {
          data.isCancelAll = true;
        }
        if (this.cancelType.value) {
          if (this.cancelType.value == "Other’s") {
            data.cancelAdvanceReason =
              this.cancelType.value + " - " + this.cancellationReason;
          } else {
            data.cancelAdvanceReason = this.cancelType.value;
          }
        }

        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        const { apiUrl } = this.constants;
        this.axios.post(`${apiUrl}/dmsAdmin/cancelAdvance`, data, config).then(
          (response) => {
            const { data } = response.data;
            this.x.success = true;
            this.cancelDialog = false;
            this.cancelType = "";
            this.cancellationReason = "";
            this.loading = false;
            this.$route.name != "Accounts"
              ? this.$eventBus.$emit("refresh-job")
              : "";
            this.$emit("account-list-refresh");
            this.$emit("assignment-list-refresh");
          },
          (error) => {
            this.error = error.response.data.message;
            this.loading = false;
          }
        );
      } else {
        this.loading = false;
        return;
      }
    },

    closeMessage() {
      this.x.success = false;
      this.componentKey += 1;
      this.$emit("on-block");
      this.$emit("assignment-list-refresh");
      this.$emit("account-list-refresh");
    },
    getTime3(date) {
      return moment(date).format("ll LT");
    },
    getTime4(date) {
      return moment(date).format("ll");
    },
    getJobType(type) {
      switch (type) {
        case "1":
          return "Land";
        case "2":
          return "Air";
        case "3":
          return "Sea";
        default:
          return "Land";
      }
    },
    callback(res) {
      this.loading = false;
      this.totalAdvanceRequested = [];
      this.$eventBus.$emit("data", res.assignmentDetails[0]);
      this.jobType = res.assignmentDetails[0].jobType || "1";
      this.headers = generateAdvanceList.map((header) => {
        if (header.text === "Driver Payment Details") {
          return { ...header, text: `${this.operatorRoleLabel} Payment Details` };
        }
        if (header.text === "Name, ID, Truck no.") {
          return {
            ...header,
            text: `Name, ID, ${getUnitNoLabel(this.jobType)}`,
          };
        }
        return header;
      });
      this.assignDetails = res.assignmentDetails[0];
      this.advanceAmount = res.assignmentDetails[0].advanceAmount;
      this.totaladvancePaid = res.assignmentDetails[0].totalAdvancePaidAmount;
      this.assignedToTransporter =
        res.assignmentDetails[0].assignedToTransporter;
      this.maximumAdvanceLeftAmount =
        res.assignmentDetails[0].maximumAdvanceLeftAmount;
      this.totaldata = res.assignmentDetails[0].totalAmount;
      this.ownerType = res.assignmentDetails[0].ownerType;
      this.purchaseInvoiceGenerated =
        res.assignmentDetails[0].isPurchaseInvoiceGenerated;

      console.log(res);
      res.list.filter((x) => {
        if (x.advanceStatus != "Cancel" && x.advanceStatus != "Paid") {
          this.totalAdvanceRequested.push(x.advanceAmount);
        }
      });
      this.isMarkedAllRead = res.isReadyToPay;
      this.invoiceCity = res.invoicingCity;
      this.assignmentDetails = res.assignmentDetails[0];
      this.invoiceCompany = res.invoicingCompany;
      this.$eventBus.$emit("off-load");
      this.paymentAmount = res.assignmentDetails[0].paymentAmount;
      this.currency = res.assignmentDetails[0].customerCurrency;
      this.advanceStatus = res.isCancel;

      this.assignID = res.assignmentDetails[0].assignmentId;
      this.status = res.assignmentDetails[0].assignmentStatus;
      this.items = res.list;
      this.getBankName();
      this.totalPages = Math.ceil(res.totalData / 15);
      // window.scrollTo(0, 0);
    },

    paginationPayload(event) {
      this.payload = event;
      this.loading = true;
    },
  },
};
</script>
<style lang="scss">
.pd__left__4 .v-toolbar__content {
  padding-left: 10px !important;
}
</style>

<style scoped>
.advance-details-card,
.advance-cancel-card {
  background: #ffffff !important;
  border: 0.0625rem solid #ebe9e2 !important;
  border-radius: 1rem !important;
  box-shadow: 0 1.25rem 2.5rem rgba(28, 43, 95, 0.14) !important;
  overflow: hidden;
  padding: 0 !important;
}

.advance-cancel-header {
  align-items: center;
  background: #fff7ed;
  border-bottom: 0.0625rem solid #fed7aa;
  display: flex;
  justify-content: space-between;
  padding: 0.85rem 1rem;
}

.advance-cancel-header__brand {
  align-items: center;
  display: flex;
  gap: 0.65rem;
  min-width: 0;
}

.advance-cancel-header__badge {
  align-items: center;
  background: #1c2b5f;
  border-radius: 0.55rem;
  color: #ffffff;
  display: inline-flex;
  flex: 0 0 auto;
  height: 2rem;
  justify-content: center;
  width: 2rem;
}

.advance-cancel-header__badge .v-icon {
  color: #ffffff !important;
  font-size: 1.05rem !important;
}

.advance-cancel-title-text {
  color: #1c2b5f;
  font-size: 0.975rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.3;
  margin: 0;
}

.advance-cancel-close {
  color: #74716a !important;
  height: 2rem !important;
  margin: 0 !important;
  width: 2rem !important;
}

.advance-cancel-close .v-icon {
  color: #74716a !important;
  font-size: 1.125rem !important;
}

.advance-cancel-body {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  padding: 1rem 1.1rem 0.35rem;
}

.advance-cancel-field {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.advance-cancel-label {
  color: #8a857c;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.advance-cancel-actions {
  background: #fffaf4 !important;
  border-top: 0.0625rem solid #fed7aa;
  gap: 0.5rem;
  padding: 0.7rem 1rem !important;
}

.advance-details-header {
  align-items: center;
  background:
    radial-gradient(circle at 100% 0%, rgba(245, 130, 32, 0.14), transparent 42%),
    linear-gradient(135deg, #fff7ed 0%, #ffffff 55%, #f4f7fb 100%);
  border-bottom: 0.0625rem solid #fed7aa;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  min-height: 3.25rem;
  padding: 0.7rem 1rem;
}

.advance-details-header__brand {
  align-items: center;
  display: flex;
  gap: 0.7rem;
  min-width: 0;
}

.advance-details-header__badge {
  align-items: center;
  background: linear-gradient(160deg, #1c2b5f 0%, #2a3f7a 100%);
  border-radius: 0.7rem;
  box-shadow: 0 0.35rem 0.75rem rgba(28, 43, 95, 0.22);
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.35rem;
  justify-content: center;
  position: relative;
  width: 2.35rem;
}

.advance-details-header__badge::after {
  background: #f58220;
  border-radius: 999px;
  bottom: 0.26rem;
  content: "";
  height: 0.18rem;
  left: 0.48rem;
  position: absolute;
  right: 0.48rem;
}

.advance-details-header__badge .v-icon {
  color: #ffffff !important;
  font-size: 1.05rem !important;
  margin-top: -0.1rem;
}

.advance-details-title {
  color: #1c2b5f;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.2;
  margin: 0;
}

.advance-details-toolbar,
.advance-cancel-title {
  background: #fff7ed !important;
  border-bottom: 0.0625rem solid #fed7aa;
  color: #1c2b5f !important;
  min-height: 3.25rem;
  padding: 0.7rem 1rem !important;
}

.advance-details-toolbar ::v-deep .v-toolbar__content {
  padding: 0 !important;
}

.advance-details-toolbar ::v-deep .v-toolbar__title,
.advance-cancel-title .headline {
  color: #1c2b5f !important;
  font-size: 1rem !important;
  font-weight: 800;
  letter-spacing: 0 !important;
}

.advance-details-close {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  color: #5b6475 !important;
}

.advance-details-close ::v-deep .v-icon {
  color: #5b6475 !important;
}

.advance-details-summary {
  align-items: center;
  background: #fffaf4;
  border: 0.0625rem solid #fed7aa;
  border-radius: 0.75rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem 1rem;
  justify-content: flex-end;
  margin: 0.75rem 0.85rem 0.5rem;
  padding: 0.7rem 0.85rem !important;
  white-space: normal;
}

.advance-details-summary .flex {
  flex: 0 1 auto !important;
  max-width: none !important;
  min-width: max-content;
  padding: 0 !important;
}

.advance-action-secondary,
.advance-action-primary {
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  height: 2.25rem !important;
  letter-spacing: 0 !important;
  min-width: 5.25rem !important;
  text-transform: none !important;
}

.advance-action-secondary {
  background: transparent !important;
  border: 0.0625rem solid #ebe9e2 !important;
  color: #3a382f !important;
}

.advance-action-primary {
  background: #ea7a1c !important;
  border: 0.0625rem solid #ea7a1c !important;
  color: #ffffff !important;
}

.advance-action-primary ::v-deep .v-btn__content {
  color: #ffffff !important;
}

.dashboard-style {
  color: #8a857c;
  font-size: 0.8125rem;
  font-weight: 700;
}
.p-16 {
  padding: 8px !important;
}

.customer-actions {
  padding: 0;
  margin: auto 20px auto 0px;
  cursor: pointer;
}
.text-center {
  text-align: center;
}
.document {
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  text-transform: uppercase;
  color: #666666;
}
.editCustomer {
  margin: auto 0;
}

.page-count-span {
  color: #c35f02;
  float: right;
  font-size: 0.8125rem;
  font-weight: 700;
  margin-top: 1rem;
}
.color-black {
  color: #000000 !important;
}
.cancel-ass-btn {
  text-decoration: none;
  color: #ffffff;

  border-radius: 5px;
  border: 2px solid red;
  padding: 2px 0px;
}
.reject-ass-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: red;
  border-radius: 5px;
  border: 2px solid red;
  padding: 2px 0px;
}
.m-t-10 {
  margin-top: 10px;
}
.m-l-10 {
  margin-left: 10px;
}
.p-b-0 {
  padding-bottom: 0px !important ;
}
.p-t-0 {
  padding-top: 0px !important ;
}
.text-stylee {
  font-size: 20px;
}
</style>

<style>
/* Cancel Advance dialog only — keeps Save label visible */
.application .v-dialog.advance-cancel-dialog {
  border-radius: 1rem !important;
  overflow: hidden !important;
}

.application .v-dialog.advance-cancel-dialog .advance-cancel-card {
  border-radius: 1rem !important;
  box-shadow: none !important;
}

.application
  .v-dialog.advance-cancel-dialog
  .advance-cancel-actions
  .advance-cancel-secondary-btn.v-btn {
  background: #ffffff !important;
  border: 0.0625rem solid #ebe9e2 !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  color: #3a382f !important;
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  height: 2.25rem !important;
  letter-spacing: 0 !important;
  min-width: 5.25rem !important;
  text-transform: none !important;
}

.application
  .v-dialog.advance-cancel-dialog
  .advance-cancel-actions
  .advance-cancel-secondary-btn.v-btn
  .v-btn__content {
  color: #3a382f !important;
}

.application
  .v-dialog.advance-cancel-dialog
  .advance-cancel-actions
  .advance-cancel-primary-btn.v-btn,
.application
  .v-dialog.advance-cancel-dialog
  .advance-cancel-actions
  .advance-cancel-primary-btn.v-btn.orange,
.application
  .v-dialog.advance-cancel-dialog
  .advance-cancel-actions
  .advance-cancel-primary-btn.v-btn.orange--text {
  background: #ea7a1c !important;
  border: 0.0625rem solid #ea7a1c !important;
  border-radius: 0.5rem !important;
  box-shadow: 0 0.125rem 0.5rem rgba(234, 122, 28, 0.25) !important;
  color: #ffffff !important;
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  height: 2.25rem !important;
  letter-spacing: 0 !important;
  min-width: 5.25rem !important;
  opacity: 1 !important;
  text-transform: none !important;
}

.application
  .v-dialog.advance-cancel-dialog
  .advance-cancel-actions
  .advance-cancel-primary-btn.v-btn
  .v-btn__content {
  color: #ffffff !important;
  opacity: 1 !important;
}

.application
  .v-dialog.advance-cancel-dialog
  .advance-cancel-actions
  .advance-cancel-primary-btn.v-btn--disabled,
.application
  .v-dialog.advance-cancel-dialog
  .advance-cancel-actions
  .advance-cancel-primary-btn.v-btn[disabled] {
  background: #f3ece4 !important;
  border-color: #e2d5c6 !important;
  box-shadow: none !important;
  color: #8a6a4a !important;
  opacity: 1 !important;
}

.application
  .v-dialog.advance-cancel-dialog
  .advance-cancel-actions
  .advance-cancel-primary-btn.v-btn--disabled
  .v-btn__content,
.application
  .v-dialog.advance-cancel-dialog
  .advance-cancel-actions
  .advance-cancel-primary-btn.v-btn[disabled]
  .v-btn__content {
  color: #8a6a4a !important;
  opacity: 1 !important;
}
</style>
